import { ThreatMapResponse } from '@bartizo/shared';
import { apiRequest } from './client.js';

export function getThreatMap(hours: number, serverId?: string): Promise<ThreatMapResponse> {
  const params = new URLSearchParams({ hours: String(hours) });
  if (serverId !== undefined) params.set('server_id', serverId);
  return apiRequest(`/threat-map?${params.toString()}`, { schema: ThreatMapResponse });
}
